export default {
  features: {
    index: {
      seo: {
        title: 'All Features',
        description:
          'AI-powered tools for delivery management: branded tracking, route optimization, AI agents, proof of delivery, auto allocation, analytics, and more.',
      },
      badge: 'Platform Features',
      title: 'All features',
      subtitle:
        'AI-powered tools for delivery, routing, proof of delivery, and fleet operations. Explore each feature below and jump to the dedicated page for details.',
      stats: {
        features: 'Features',
        aiPowered: 'AI-powered',
        dispatchRouting: 'Dispatch & routing',
        uptime: 'Platform uptime',
      },
      learnMore: 'Learn more',
      cta: {
        title: 'Ready to try Geofleet?',
        subtitle: 'Get started or book a demo to see how these features work for your operations.',
      },
    },
  },
};
